// src/components/AutoTextarea.jsx
import { useLayoutEffect, useRef } from 'react';

/** Autosizes to fit content (min-rows = 2, max = 14 rem). */
export default function AutoTextarea({
    value,
    onChange,
    onBlur = () => { },
    placeholder = 'Skriv beskrivelse …',
    className = '',
    style = {},
}) {
    const ref = useRef(null);

    /* grow / shrink to content */
    useLayoutEffect(() => {
        if (!ref.current) return;
        ref.current.style.height = 'auto';
        ref.current.style.height = `${Math.min(ref.current.scrollHeight, 224)}px`;
    }, [value]);

    return (
        <textarea
            ref={ref}
            rows={2}
            value={value}
            onChange={e => onChange(e.target.value)}
            onBlur={onBlur}
            placeholder={placeholder}
            className={className}
            style={{ resize: 'none', ...style }}
        />
    );
}
